import type { ComponentChildren } from 'preact'
import styles from './Screen.module.css'

interface ScreenProps {
  /** Large navigation title (docs/ui-ux-spec.md interaction conventions). */
  title: string
  /**
   * A restrained mark trailing the title. **Today passes one and no other screen
   * does** (D-089) — it is an application signature, not a per-section decoration,
   * and repeating it on all five tabs would make it wallpaper.
   *
   * Whatever is passed must be decorative. It renders as a *sibling* of the `h1`,
   * never inside it: content within the heading joins its accessible name, and the
   * suite queries Today by `getByRole('heading', { name: 'Today' })`.
   */
  headerAccessory?: ComponentChildren
  children?: ComponentChildren
}

/**
 * Standard screen frame: safe-area padding, a large title, and bottom spacing
 * that clears the fixed tab bar so content is never trapped behind it.
 */
export function Screen({ title, headerAccessory, children }: ScreenProps) {
  return (
    <main id="main-content" class={styles.screen} tabIndex={-1}>
      <header class={styles.header}>
        <h1 class={styles.title}>{title}</h1>
        {headerAccessory}
      </header>
      <div class={styles.content}>{children}</div>
    </main>
  )
}
